import * as angular from 'angular';
import * as template from './template.html';
import './styling.scss';

import * as desktopCoveragePolicyCardComponent from './desktop';
import * as mobileCoveragePolicyCardComponent from './mobile';
import './desktop';
import './mobile';
import { CurrentUserService } from 'services/currentUser';
import { getAutoRenewal, getRenewalDate } from 'common/source/utilities/policyInfoHelper';
import { getPolicyEffectiveDateRange } from 'common/source/utilities/policyInfoDisplay';

const module = angular.module('coverage-policy-card', [
    desktopCoveragePolicyCardComponent.module.name,
    mobileCoveragePolicyCardComponent.module.name
]);

interface CoveragePolicyCardController extends angular.IStrictController {
    policyNumber: string;
    policyRenewalDate: string;
    policyAutoRenewal: string;
    policyEffectiveDateRange: string;
}

module.component('coveragePolicyCard', {
    template: template,
    controller: function(
        this: CoveragePolicyCardController,
        currentUserService: CurrentUserService,
        $stateParams: PolicyStateParams
    ) {
        'ngInject';

        const policyIndex = $stateParams.policyIndex;
        currentUserService.getCustomerPolicyInfoByIndex(policyIndex).then((policyInfo) => {
            this.policyNumber = policyInfo.policy_number;
            this.policyRenewalDate = getRenewalDate(policyInfo);
            this.policyAutoRenewal = getAutoRenewal(policyInfo) ? 'ON' : 'OFF';
            this.policyEffectiveDateRange = getPolicyEffectiveDateRange(policyInfo);
        });
    }
});

export { module };
